import React, { Component } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Transition } from "react-transition-group";

import "./style.scss";

class Modal extends Component {
  static propTypes = {
    size: PropTypes.oneOf([
      1000,
      800,
      700,
      600,
      550,
      500,
      450,
      400,
      350,
      300,
      860,
      420,
    ]),
    closeIcon: PropTypes.bool,
    isOpen: PropTypes.bool,
    toggle: PropTypes.func,
    backdrop: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.oneOf(["static"]),
    ]),
    scroll: PropTypes.bool,
    zIndex: PropTypes.number,
  };

  static defaultProps = {
    size: 500,
    closeIcon: true,
    isOpen: false,
    backdrop: true,
    scroll: false,
    zIndex: 1050,
  };

  _toggleAction = () => {
    this.props.toggle();
  };

  componentDidMount() {
    window.addEventListener('keydown', this.handleEsc);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleEsc);
  }

  handleEsc = (event) => {
    if (event.key === 'Escape' && this.props.isOpen) {
      this._toggleAction();
    }
  }

  render() {
    const { size, closeIcon, isOpen, backdrop, scroll, className, zIndex } = this.props;

    const classNames = cx("mx-modal-wrapper", size && `max-w-${size}`);

    const classNames2 = cx(
      "mx-modal-box",
      className,
      scroll && "overflow-scroll"
    );

    const defaultStyle = {
      transition: "all .4s ease .2s",
      opacity: 0,
      visibility: "hidden",
    };

    const transitionStyles = {
      entering: { opacity: 0, visibility: "hidden" },
      entered: {
        opacity: 1,
        visibility: "visible",
        transition: "all .2s ease .0s",
      },
      exited: { opacity: 0, visibility: "hidden" },
    };

    const defaultModalStyle = {
      transition: "all .1s ease",
      opacity: 0,
      visibility: "hidden",
      transform: "translateY(-20px)",
    };

    const transitionModalStyles = {
      entering: { opacity: 0, visibility: "hidden" },
      entered: {
        opacity: 1,
        visibility: "visible",
        transform: "translateY(0)",
        transition: "all .2s ease .1s",
      },
      exited: { opacity: 0, visibility: "hidden" },
    };

    return (
      <Transition
        in={isOpen}
        timeout={{
          enter: 0,
          exit: 400,
        }}
        unmountOnExit
      >
        {(state) => (
          <div
            className="mx-main-modal-container"
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
              zIndex,
            }}
          >
            <div className="mx-main-modal">
              <div
                className="mx-main-modal-overlay"
                onClick={() =>
                  backdrop === true ? this._toggleAction() : () => {}
                }
                style={{
                  ...defaultStyle,
                  ...transitionStyles[state],
                }}
              >
                {" "}
              </div>
              <div
                className={classNames}
                style={{
                  ...defaultModalStyle,
                  ...transitionModalStyles[state],
                }}
              >
                {closeIcon && (
                  <div className="close-btn" onClick={this._toggleAction}>
                    {" "}
                  </div>
                )}
                <div className={classNames2}>{this.props.children}</div>
              </div>
            </div>
          </div>
        )}
      </Transition>
    );
  }
}

export default Modal;
